import * as React from "react";
import { EditableText, Button } from "@blueprintjs/core";
import { css } from "@emotion/core";

interface EditableLabelProps {
  value: string;
  onSave: (value: string) => void;
}

export function EditableLabel({ value, onSave }: EditableLabelProps) {
  const inputRef = React.useRef<EditableText>(null);

  const [displayValue, setDisplayValue] = React.useState(value);

  const handleConfirm = (value: string) => {
    onSave(value.trim());
  };

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        gap: 0.5rem;
      `}
    >
      <EditableText
        ref={inputRef}
        value={displayValue}
        onChange={setDisplayValue}
        onConfirm={handleConfirm}
        placeholder="Enter label..."
        selectAllOnFocus={true}
        confirmOnEnterKey={true}
      />
      <Button
        icon="edit"
        size="small"
        onClick={() => inputRef.current?.toggleEditing()}
      />
    </div>
  );
}
